export const fillArray = (amount: number) => Array(amount).fill('');
